module.exports = __webpack_public_path__ + "img/builds.c091606a.png";